import { z } from 'zod';

export const signupSchema = z.object({
    fname: z
        .string()
        .min(1, { message: 'First name is required' })
        .max(50, { message: 'First name must be less than 50 characters' }),
    lname: z
        .string()
        .min(1, { message: 'Last name is required' })
        .max(50, { message: 'Last name must be less than 50 characters' }),
    organization_name: z
        .string()
        .min(1, { message: 'Organization name is required' })
        .max(100, { message: 'Organization name must be less than 100 characters' }),
    email: z
        .string()
        .min(1, { message: 'Email is required' })
        .email({ message: 'Please enter a valid email address' }),
    password: z
        .string()
        .min(8, { message: 'Password must be at least 8 characters' })
        .regex(/[a-z]/, { message: 'Password must contain at least one lowercase letter' })
        .regex(/[A-Z]/, { message: 'Password must contain at least one uppercase letter' })
        .regex(/[0-9]/, { message: 'Password must contain at least one number' })
        .regex(/[^a-zA-Z0-9]/, { message: 'Password must contain at least one special character' }),
    password_confirmation: z
        .string()
        .min(1, { message: 'Please confirm your password' })
}).refine((data) => data.password === data.password_confirmation, {
    message: 'Passwords do not match',
    path: ['password_confirmation']
});

export type SignupFormValues = z.infer<typeof signupSchema>;